import styled from 'styled-components';

const CONTAINER_HEIGHT_IN_PX = 48;
const BAR_WIDTH_IN_PX = 3;
const BAR_GAP_IN_PX = 2;
const BAR_BORDER_RADIUS_IN_PX = 2;
const BAR_MIN_HEIGHT_IN_PX = 3;

export const StyledVisualizerContainer = styled.div`
   display: flex;
   flex-direction: row;
   align-items: flex-end;
   justify-content: center;
   gap: ${BAR_GAP_IN_PX}px;
   height: ${CONTAINER_HEIGHT_IN_PX}px;
   width: 100%;
   background-color: ${(props) => props.theme.white};
   border-radius: 8px;
   padding: 8px 12px;
   box-sizing: border-box;
`;

StyledVisualizerContainer.displayName = 'StyledVisualizerContainer';

type StyledVisualizerBarProps = {
   $height: number;
};

export const StyledVisualizerBar = styled.div<StyledVisualizerBarProps>`
   width: ${BAR_WIDTH_IN_PX}px;
   min-height: ${BAR_MIN_HEIGHT_IN_PX}px;
   height: ${(props) => props.$height}px;
   border-radius: ${BAR_BORDER_RADIUS_IN_PX}px;
   background-color: ${(props) => props.theme.primary};
   transition: height 100ms ease-out;
`;

StyledVisualizerBar.displayName = 'StyledVisualizerBar';
